import { get } from 'services/api';

export const CHANGE_USER_URL = '/settings/changeUserAndProject';

type userProjectProps = {
  userEmail: string;
  projectId: number;
};

export const changeUserAndProjectAPI = ({ userEmail, projectId }: userProjectProps) =>
  get(`${CHANGE_USER_URL}?email=${userEmail}&projectId=${projectId}`);
